import React from "react";
import {Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import VmtTree from "../../../components/TreeView/VmtTree";
import {showFaq} from "../services";
import {filterTripletsByUserLevel} from "../../../utils";
import {defaultSearchFilter} from "../../../utils/constants";
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";

const useStyles = makeStyles(() => ({
  mainPaper: {
    marginTop: 10,
    padding: 15
  },
  button: {
    float: 'right'
  },
  link: {
    cursor: "pointer",
  }
}));

function VerticalDetailView({
                              selectedVertical,
                              triplets,
                              faqSelection,
                              setScrollToObject,
                              vmtSelection,
                              setEditableFaq,
                              toggleNewFaqDialog,
                              setNavigationStatus,
                              fetchFaqs,
                              isAdmin,
                              userData,
                              openAlert
                            }) {

  const classes = useStyles();
  const apiRequest = useCountryAxiosInstance();
  // console.log('selectedVertical', selectedVertical)

  let tripletsFiltered = triplets.filter(function (item) {
    return item.vertical === selectedVertical
  }).filter(function (item) {
    return item.questions !== undefined && item.questions.length > 0
  })
    .filter(function (item) {
      return item.tema !== undefined && item.tema !== ''
    })

  tripletsFiltered = filterTripletsByUserLevel(tripletsFiltered, userData)

  let lastMacro = '';

  const showMacro = (tripletItem) => {
    const newSection = tripletItem.macrotema !== lastMacro
    if (newSection) {
      lastMacro = tripletItem.macrotema
    }
    return (
      <div key={Math.random()}>
        {newSection &&
        <Typography
          id={tripletItem.macrotema.concat(tripletItem.vertical).concat('treeItem')}
          variant="h4"
          style={{marginTop: 10}}
        >
          {tripletItem.macrotema}
        </Typography>
        }
        <Typography
          id={tripletItem.tema.concat(tripletItem.macrotema.concat(tripletItem.vertical).concat('treeItem'))}
          variant="h6"
          color="primary"
          style={{fontWeight: "bold", marginTop: 15}}
        >
          {tripletItem.tema}
        </Typography>
        {Object.values(tripletItem.questions).map((question) =>
          showFaq(question, 'faq_detail', defaultSearchFilter, faqSelection, vmtSelection,
            setScrollToObject, setNavigationStatus, setEditableFaq, toggleNewFaqDialog, fetchFaqs, isAdmin,
            true, classes, openAlert, apiRequest)
        )}
        <div style={{height: 20}}/>
      </div>
    )

  }
  const isMobile = window.innerWidth < 500;
  const mainWidth = isMobile ? 12 : 9;

  return (
    <>
      <Grid
        container
      >
        {!isMobile && tripletsFiltered.length > 0 &&
        <Grid item xs={3}>
          <VmtTree
            selectedVertical={selectedVertical}
            triplets={triplets}
            setScrollToObject={setScrollToObject}
            setNavigationStatus={setNavigationStatus}
            userData={userData}
            vmtSelection={vmtSelection}
          />
        </Grid>
        }


        {tripletsFiltered.length > 0 &&
        <Grid item xs={mainWidth}>
          {Object.values(tripletsFiltered).map((tripletItem) =>
            showMacro(tripletItem)
          )}

        </Grid>}
        {tripletsFiltered.length === 0 &&
        <div key='no_result_label' style={{margin: 5}}>
          <Typography variant="h6" align="center">
            Nessun risultato ottenuto
          </Typography>
        </div>

        }
      </Grid>

    </>
  )
}

export default VerticalDetailView;